<template>
<div>
  <v-card>
    <v-card-title>
      Eventos
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="event"
      :search="search"
      :loading="loadingTable"
    >
      <template slot="items" slot-scope="props">

        <td class="text-xs-center">{{ props.item.events_date }} {{ props.item.events_time }}</td>
        <td class="text-xs-center">{{ props.item.responsible_name }}</td>
        <td class="text-xs-center">{{ props.item.description }}</td>
        <td class="text-xs-center">{{ props.item.category }}</td>
        <td class="text-xs-center">{{ props.item.requires_signature == 1 ? 'Sí' : 'No'}}</td>
        <td class="text-xs-center">{{ props.item.close_assistance == 1 ? 'Sí' : 'No'}}</td>
        <td class="text-xs-center">{{ props.item.delegate_allowed == 1 ? 'Sí' : 'No'}}</td>
        <td class="text-xs-center" :class="props.item.status == 1 ? 'red--text' : ''">{{ props.item.status == 0 ? 'Abierta' : 'Cerrada' }}</td>
        <td class="text-xs-center">
          <v-tooltip top> 
            <v-icon
              :disabled="props.item.status == 1"
              medium
              class="mr-2"
              @click="takeAssistance(props.item.id)"
              slot="activator"
            >
              assignment
            </v-icon>
          <span>Tomar asistencia</span>
        </v-tooltip>
        <v-tooltip top>
          <v-icon
            medium
            class="mr-2"
            @click="charts(props.item.id)"
            slot="activator"
          >
            bar_chart
          </v-icon>
          <span>Ver informes</span>
        </v-tooltip>
          <!--<v-tooltip top>
          <v-icon
            medium
            class="mr-2"
            @click="editItem(props.item)"
            slot="activator"
          >
            edit
          </v-icon>
          <span>Editar</span>
        </v-tooltip>-->
          <v-tooltip top>
          <v-icon
            medium
            @click="deleteItem(props.item)"
            slot="activator"
          >
            delete
          </v-icon>
          <span>Eliminar</span>
        </v-tooltip>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Miembros de junta asamblea {{ dialogAssembly }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row>
              <v-flex xs10>
                <v-autocomplete
                  v-model="currentMemberSearch"
                  :items="usersResult"
                  :loading="isLoading"
                  :search-input.sync="searchBoardMembers"
                  color="primary"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="name"
                  placeholder="Buscar personas"
                  return-object
                ></v-autocomplete>
              </v-flex>
              <v-flex xs1>
                <v-btn @click="addMember()" flat icon color="primary">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs1>
                <v-btn @click="showCreateMemberForm = true" icon color="primary">
                  <v-icon>person_add</v-icon>
                </v-btn>
              </v-flex>


            </v-layout>
            <v-layout v-show="showCreateMemberForm" wrap>
              <v-flex xs12>
                <form @submit.prevent="createMemberUser" @keydown="createMemberForm.onKeydown($event)">
                  <text-input
                    :form="createMemberForm"
                    label="Nombre completo"
                    :v-errors="errors"
                    :value.sync="createMemberForm.name"
                    counter="30"
                    name="name"
                    v-validate="'required|max:30'"
                  ></text-input>
                </form>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-data-table
                :headers="boardMembersHeaders"
                :items="boardMembers"
                :search="boardMembersSearch"
              >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.description }}</td>
                <td class="text-xs-center">
                  <v-icon
                    small
                    @click="deleteMember(props.item.description, props.item.id)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
              </v-data-table>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</div>

</template>
<script>
import axios from 'axios'
import Form from 'vform';

export default {
  name: 'event-show-view',
  data() {
    return {
      search: '',
      headers: [
        { text: 'Fecha de evento', align: 'center', value: 'events_date' },
        { text: 'Responsable', align: 'center', value: 'responsible_name' },
        { text: 'Descripcion', align: 'center', value: 'description' },
        { text: 'Categoría', align: 'center', value: 'category' },
        { text: 'Firma', align: 'center', value: 'requires_signature', sortable: false, width: "5" },
        { text: 'Cerrar', align: 'center', value: 'close_assistance', sortable: false, width: "10px" },
        { text: 'Delegado', align: 'center', value: 'delegate_allowed', sortable: false, width: "10px" },
        { text: 'Estado', align: 'center', value: 'status' },
        { text: 'Acciones', align: 'center', value: 'events_date', sortable: false }
      ],
      event: [],
      dialogAssembly: '',
      dialogIdAssembly: 0,
      dialog: false,
      userNameMaxLength: 60,
      entries: [],
      isLoading: false,
      currentMemberSearch: null,
      searchBoardMembers: null,
      boardMembersHeaders: [
        { text: 'Nombre', value: 'name', align: 'center' },
        { text: 'Actions', value: 'name', sortable: false, align: 'center' }
      ],
      boardMembers: [],
      boardMembersSearch: '',
      showCreateMemberForm: false,
      createMemberForm: new Form({
        name: ''
      }),
      loadingTable: false,
    }
  },
  created() {
    this.getEventList()
  },
  methods: {
    async getEventList() {
      this.loadingTable = true;
      axios.get('/api/events').then(resp=>{
        console.log(resp + "respo")
      this.event = resp.data;
      })
      this.loadingTable = false;
    },
    editItem(item) {
      this.$router.push({ name: 'event.edit', params: {id: item.id}});
    },
    async deleteItem(item) {
      axios.delete(`/api/events/${item.id}`).then(resp=>{
        this.getEventList();
      }).catch(error=>{
        console.log(error);
      })
    },
    takeAssistance(eventId) {
      this.$router.push({ name: 'event.take_assistance', params: { id: eventId } })
    },
    charts(eventId) {
      this.$router.push({ name: 'event.report', params: { id: eventId } })
    }
  },
  computed: {
    usersResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    }
  },

  watch: {
    searchBoardMembers(val) {
      if (!val) return
      if (this.isLoading) return

      this.isLoading = true

      axios.get(`/api/assembly/search_board_members/${val}`)
        .then(res => {
          const { data } = res
          this.count = data.length;
          this.entries = data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/event/show.vue